import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardGenerateContinueByDateUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardGenerateContinueByDateUX-div-0"
        style={{ height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardGenerateContinueByDateUX-div-1"
          style={{ marginBottom: "40px" }}>

          <FormGroup
            id="CardGenerateContinueByDateUX-FormGroup-4"
            inline={true}>
            <FormField
              id="CardGenerateContinueByDateUX-FormField-5"
              inline={true}>
              <div
                id="CardGenerateContinueByDateUX-div-7"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardGenerateContinueByDateUX-label-9">
                  Date
                </label>
                <DateTextBox
                  id="CardGenerateContinueByDateUX-DateTextBox-10"
                  onChange={props.onChangeDate}
                  value={props.generateContinueData?.date || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardGenerateContinueByDateUX-FormField-6"
              inline={true}>
              <div
                id="CardGenerateContinueByDateUX-div-8"
                style={{ width: "100%" } }>

                <div
                  id="CardGenerateContinueByDateUX-div-11">
                  {props.generateButton}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardGenerateContinueByDateUX-FormField-12"
              inline={true}>
              <div
                id="CardGenerateContinueByDateUX-div-13"
                style={{ width: "100%" } }>

                <div
                  id="CardGenerateContinueByDateUX-div-14">
                  {props.refreshButton}
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardGenerateContinueByDateUX-div-2">

          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.continueList}
            id="CardGenerateContinueByDateUX-Table-3"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
      </div>
    )
}


export default CardGenerateContinueByDateUX

export const screenPropsDefault = {}

/* Date Time : Mon Jul 14 2025 18:19:10 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"40px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 3,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.continueList"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-Table-3"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-label-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 10,
      "name": "DateTextBox",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-DateTextBox-10"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.generateContinueData?.date || \"\""
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.generateButton"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-div-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.refreshButton"
        },
        "id": {
          "type": "value",
          "value": "CardGenerateContinueByDateUX-div-14"
        }
      },
      "seq": 14,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardGenerateContinueByDateUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
